import { VFlow } from 'bold-ui'
import { MChatRiscoEnum } from 'graphql/types.generated'
import React from 'react'

import { MChatRfAccordion } from './components/MChatRfAccordion'
import { ConsultaSeguimentoView } from './consulta-seguimento/consulta-seguimento-view/ConsultaSeguimentoView'
import { MChatView } from './mchat/mchat-view/MChatView'
import { MChatRfViewModel } from './model-mChatRf'

interface MChatRfViewProps {
  value: MChatRfViewModel
}

export function MChatRfView(props: Readonly<MChatRfViewProps>) {
  const { value } = props

  const isMChatRiscoElevado = value.mchat?.risco === MChatRiscoEnum.ELEVADO
  const isMChatRiscoMedio = value?.mchat?.risco === MChatRiscoEnum.MEDIO

  return (
    <MChatRfAccordion>
      <VFlow vSpacing={0}>
        <MChatView value={value?.mchat} />
        {!isMChatRiscoElevado && (
          <ConsultaSeguimentoView value={value?.consultaSeguimento} isMChatRiscoMedio={isMChatRiscoMedio} />
        )}
      </VFlow>
    </MChatRfAccordion>
  )
}
